import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { endpointApi } from '../utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../redux/actions/auth.action';
import { useDispatch } from 'react-redux';

export default function SearchSupplier({ id="supplier_id", updateSupplier=null, defaultValue=null, required=false, reset=false }) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const autocompleteListRef = useRef(null);
    const autocompleteInputRef = useRef(null);
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [q, setQ] = useState("");
    const [supplier, setSupplier] = useState(defaultValue);
    const [suppliers, setSuppliers] = useState([]);

    useEffect(() => {
        if(reset){
            setIsTouched(false);
        }
    }, [reset]);

    const searchSuppliers = useCallback(async (q=null) => {
        try {
            const jwt_access = localStorage.getItem('jwt_access');
            const { data } = await axios.get(`${ endpointApi }suppliers/search${ q ? '?q=' + q : '' }`, {
                headers: {
                    'Authorization': `Bearer ${ jwt_access }`
                }
            });
            setSuppliers(data);
        } catch (err) {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }
        }
    }, [dispatch, navigate, location]);

    useEffect(() => {
        searchSuppliers();
    }, [searchSuppliers, location]);

    useEffect(() => {
        if(q.length >= 2){
            searchSuppliers(q);
        }
    }, [searchSuppliers, q]);
    
    useEffect(() => {
        setQ("");
        if(updateSupplier && supplier){
            updateSupplier(supplier);
        }
    }, [updateSupplier, supplier]);

    useEffect(() => {
        setSupplier(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        const clickOutsiteAutocompleteList = (e) => {
            if(autocompleteInputRef.current && e.target !== autocompleteInputRef.current && autocompleteListRef.current && !autocompleteListRef.current.contains(e.target) && autocompleteListRef.current.classList.contains('active')){
                setIsAutocompleteOpen(false);
            }
        }
        document.addEventListener('click', clickOutsiteAutocompleteList);
        return () => {
            document.removeEventListener('click', clickOutsiteAutocompleteList);
        }
    }, []);

    return (
        <>
            <div className='autocomplete'>
                <label htmlFor={ id } className='form-control'>{ supplier ? (supplier.type === 'Company' ? supplier.company_name : supplier.last_name + " " + supplier.first_name) : 'Rechercher un fournisseur' }</label>
                <input type='text' id={ id } ref={ autocompleteInputRef } onFocus={ () => {
                    setIsAutocompleteOpen(true);
                }} placeholder={ supplier ? (supplier.type === 'Company' ? supplier.company_name : supplier.last_name + " " + supplier.first_name) : 'Rechercher un fournisseur' } className='form-control' value={ q } onChange={ (e) => setQ(e.target.value) } onBlur={ () => setIsTouched(true) } />
                <ul className={ `autocomplete-list${ isAutocompleteOpen ? ' active' : '' }` } ref={ autocompleteListRef }>
                    { suppliers.map(item => {
                        return(
                            <li key={ item.id } onClick={ () => {
                                setSupplier(item);
                                setIsAutocompleteOpen(false);
                            } }><i className='fa fa-search'></i> { item.type === 'Company' ? item.company_name : item.last_name + " " + item.first_name }</li>
                        )
                    }) }
                    { suppliers.length === 0 && <li className='empty'>Aucun résultat trouvé</li> }
                </ul>
            </div>
            { required && isTouched && supplier === null && <div className='form-error'>Veuillez sélectionner le fournisseur.</div> }
        </>
    )
}
